import breadcrumbs from './Prize_shop_breadcrumbs';
import orderby from 'lodash.orderby';
import api from '../../api/index';

export default {
  namespaced: true,
  modules   : {
    breadcrumbs,
  },
  state: {
    themes: ['Выставки и развлечения', 'Товары и услуги', 'Здоровье и спорт', 'Все категории призов'],
    modals: [
      {
        type  : 'prizes_info_modal',
        active: false,
      },
      {
        type  : 'get_prize_modal',
        active: false,
      },
      {
        type  : 'prize_recieved_modal',
        active: false,
      },
    ],
    prizes_available: [],
    my_prizes       : [],
    selected_theme  : null,
    selected_number : 9,
    selected_page   : 1,
    price_filter    : false,
    sorting         : 'asc',
    sorting_type    : 'user',
    active_tab      : 0,
    chosen_prize_id : 0,
    chosen_prize    : {},
    next_prize_title: '',
    prev_prize_title: '',
  },
  getters: {
    themes              : ({themes}) => themes,
    prizes_available    : ({prizes_available}) => prizes_available,
    my_prizes           : ({my_prizes}) => my_prizes,
    chosen_prize_id     : ({chosen_prize_id}) => chosen_prize_id,
    chosen_prize        : ({chosen_prize}) => chosen_prize,
    next_prize_title    : ({}, {get_next_prize}) => get_next_prize && get_next_prize.title,
    prev_prize_title    : ({}, {get_prev_prize}) => get_prev_prize && get_prev_prize.title,
    prizes_info_modal   : ({modals}) => modals.find((modal)=> modal.type == 'prizes_info_modal').active,
    get_prize_modal     : ({modals}) => modals.find((modal)=> modal.type == 'get_prize_modal').active,
    prize_recieved_modal: ({modals}) => modals.find((modal)=> modal.type == 'prize_recieved_modal').active,
    selected_theme      : ({selected_theme}) => selected_theme,
    selected_number     : ({selected_number}) => selected_number,
    selected_page       : ({selected_page}) => selected_page,
    sorting             : ({sorting}) => sorting,
    price_filter        : ({price_filter}) => price_filter,
    active_tab          : ({active_tab}) => active_tab,
    get_prize_by_id({prizes_available, my_prizes}, {active_tab, chosen_prize}, id) {
      let prizes = active_tab === 0 ? my_prizes : prizes_available;
      return function(id) {
        return prizes.find((prize) => prize.MAIN_PRODUCT.ID == id);
      };
    },
    get_current_prize_by_id({prizes_available, my_prizes}, {active_tab, chosen_prize_id}) {
      let prizes = active_tab == 0 ? prizes_available : my_prizes;
      return prizes.find((prize) => prize.id == chosen_prize_id);
    },
    filtered_by_theme({prizes_available, my_prizes, active_tab}, {selected}) {
      let prizes = my_prizes;
      if (selected && selected !== 'Все категории призов') {
        return prizes.filter((item)=> item.MAIN_PRODUCT.THEME == selected);
      } else {
        return prizes;
      }
    },
    prizes_can_buy: ({prizes_available}, {}, {}, rootGetters) => {
      const user = rootGetters['profile/user/user'];
      return prizes_available.filter((prize)=>Number(prize.MAIN_PRODUCT.PRICE)<=Number(user.points));
    },
    paginated({selected_number, sorting_type, selected_page, sorting, price_filter, prizes_can_buy, my_prizes, prizes_available}, {}, {}, rootGetters) {
      let filtered = my_prizes;
      if (price_filter) {
        const user = rootGetters['profile/user/user'];
        const enough = prizes_available.filter((prize)=>Number(prize.MAIN_PRODUCT.PRICE)<=Number(user.points));
        filtered = enough;
      }
      let asc = orderby(filtered, (o) => Number(o.MAIN_PRODUCT.PRICE), 'asc');
      let desc = orderby(filtered, (o) => Number(o.MAIN_PRODUCT.PRICE), 'desc');

      if (sorting == 'asc') {
        let typeAsc = asc;
        sorting_type === 'organization' ? typeAsc = asc.filter((item) => {
          return item.MAIN_PRODUCT.THEME === 'Призы для организаций';
        }) : typeAsc = asc.filter((item) => {
          return item.MAIN_PRODUCT.THEME === 'Призы для пользователей';
        });
        return typeAsc.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      } else if (sorting == 'desc') {
        let typeDesc = desc;
        sorting_type === 'organization' ? typeDesc = desc.filter((item) => {
          return item.MAIN_PRODUCT.THEME === 'Призы для организаций';
        }) : typeDesc = desc.filter((item) => {
          return item.MAIN_PRODUCT.THEME === 'Призы для пользователей';
        });
        return typeDesc.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      } else {
        return filtered.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      }
    },
    current_prize_filtered_index({chosen_prize_id}, {filtered_by_theme}) {
      return filtered_by_theme.findIndex((prize) => prize.id === chosen_prize_id);
    },
    get_next_prize({}, {current_prize_filtered_index, filtered_by_theme}) {
      const next = filtered_by_theme[current_prize_filtered_index+ 1];
      if (next) {
        return next;
      } else {
        return filtered_by_theme[0];
      }
    },
    get_prev_prize({}, {current_prize_filtered_index, filtered_by_theme}) {
      const prev = filtered_by_theme[current_prize_filtered_index - 1];
      if (prev) {
        return prev;
      } else {
        return filtered_by_theme[filtered_by_theme.length -1];
      }
    },
  },
  mutations: {
    CLOSE_MODAL(state, type) {
      let modal = state.modals.find((modal)=> modal.type === type);
      modal.active = false;
    },
    OPEN_MODAL(state, type) {
      let modal = state.modals.find((modal)=> modal.type === type);
      if (!modal.active) {
        modal.active = true;
      }
    },
    SET_MODAL(state, obj) {
      const {type, value} = obj;
      let modal = state.modals.find((modal)=> modal.type === type);

      modal.active = value;
    },
    SET_SELECTED_THEME(state, value) {
      state.selected_theme = value;
    },
    SET_SELECTED_PAGE(state, value) {
      state.selected_page = value;
    },
    SET_ACTIVE_TAB(state, value) {
      state.active_tab = value;
    },
    SHOW_NUMBER(state, obj) {
      const {array, selected} = obj;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    SORT_BY_PRICE(state, selected) {
      if (selected=='По возрастанию баллов') {
        state.sorting = 'asc';
      } else if (selected=='По убыванию баллов') {
        state.sorting = 'desc';
      }
    },
    SORT_BY_TYPE(state, selected) {
      if (selected=='Призы для организаций') {
        state.sorting_type = 'organization';
      } else if (selected=='Призы для пользователей') {
        state.sorting_type = 'users';
      }
    },
    CLEAR_PAGES(state) {
      state.selected_page = 1;
    },
    SET_CHOSEN_PRIZE(state, prize) {
      state.chosen_prize = prize;
      state.chosen_prize_id = prize.id;
    },
    SWITCH_PRIZE(state, prize) {
      state.chosen_prize = prize;
    },
    NEXT_PRIZE(state, next_prize) {
      state.next_prize_title = next_prize.title;
    },
    PREV_PRIZE(state, prev_prize) {
      state.prev_prize_title = prev_prize.title;
    },
    PRICE_FILTER(state) {
      state.price_filter = !state.price_filter;
    },
    SET_PRIZES(state, value) {
      state.prizes_available = value.data;
      state.my_prizes = value.data;
      state.themes = value.themes;
      state.themes.unshift({'id': 0, 'text': 'Все категории призов'});
    },
  },
  actions: {
    show_number({commit, getters}, event) {
      const {filtered_by_theme} = getters;
      commit('SHOW_NUMBER', {array: filtered_by_theme, selected: event});
    },
    sorting_by_price({commit}, selected) {
      commit('SORT_BY_PRICE', selected);
      commit('CLEAR_PAGES');
    },
    sorting_by_type({commit}, selected) {
      commit('SORT_BY_TYPE', selected);
      commit('CLEAR_PAGES');
    },
    next_prize({commit, getters}) {
      const {current_prize_filtered_index, filtered_by_theme} = getters;
      const next = filtered_by_theme[current_prize_filtered_index + 1];
      let final = next || filtered_by_theme[0];
      commit('SET_CHOSEN_PRIZE', final);
    },
    prev_prize({commit, getters}) {
      const {current_prize_filtered_index, filtered_by_theme} = getters;
      const prev = filtered_by_theme[current_prize_filtered_index - 1];
      let final = prev || filtered_by_theme[filtered_by_theme.length - 1];
      commit('SET_CHOSEN_PRIZE', final);
    },
    async get_prizes({commit}) {
      try {
        const get_prizes = await api.prize_shop.get_prizes();
        this.state.my_prizes = get_prizes.data;
        commit('SET_PRIZES', get_prizes.data);
      } catch (err) {
        console.error(err);
      }
    },
    async order_prize({commit}, prize) {
      commit('OPEN_MODAL', 'prize_recieved_modal');
      commit('CLOSE_MODAL', 'get_prize_modal');
      commit('profile/user/SPEND_POINTS', prize.price, {root: true});
      try {
        await api.prize_shop.order_prize(prize.id);
        const get_prizes = await api.prize_shop.get_prizes();
        commit('SET_PRIZES', get_prizes.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
